<template>
    <v-layout class="row-status" ma-2 justify-center grow>
      <v-card class="status-message">
        <v-layout grow justify-center>
          <v-layout class="box-status" column>

            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <span v-on="on" class="status-text">
                  {{ translatedChangedBy }} alterou para {{ event.status | conversationStatus }}
                  {{ event.created_at | moment('from', 'now') }}
                </span>
              </template>
              <span>{{
                (event.created_at) | moment("DD/MM/YYYY HH:mm:ss")
              }}</span>
            </v-tooltip>
          </v-layout>
        </v-layout>
      </v-card>
    </v-layout>
  </template>
  
  <script>
  import moment from "moment";
  
  export default {
    props: ["event"], // A prop "event" já é um único evento recebido pelo componente
    computed: {
      translatedChangedBy() {
        // Ajusta o CHANGED_BY, se for "External app"
        return this.event.changed_by === "External app" ? "Rasa" : this.event.changed_by;
      },
    },
  };
  </script>
  
<style lang="scss" scoped>
  .row-status {
    max-height: max-content;
    padding: 0;
    justify-content: center;
  
    .status-message {
      border-radius: 12px;
      background-color: #e9ecef;
      padding: 4px 12px;
      text-align: center;
      font-size: 12px;
      color: #495057;
      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    }
  
    .status-text {
      font-weight: 500;
    }
  }

.theme--dark {
  .row-status {
    .status-message {
      color: rgba(255, 255, 255, 0.6);
    }
  }
}
  </style>
  